import Cookies from "js-cookie";
import { toNumber } from "lodash";
import {
  useAccountsQuery,
  Account,
} from "@/features/workspace/graphql/generated";

export const useViewerAccounts = () => {
  const authorized_person = toNumber(Cookies.get("account_id"));
  const { data, loading } = useAccountsQuery({
    skip: !authorized_person,
  });

  const accounts = data?.accounts || ([] as Account[]);
  return {
    accounts,
  };
};
